import { apiMetricsManager } from "./apiMetricsManager";

export const trackedAsync = async <T>(
  asyncFn: () => Promise<T>
): Promise<T> => {
  const start = performance.now();

  try {
    const result = await asyncFn();
    const duration = performance.now() - start;

    apiMetricsManager.record(duration, "success");

    return result;
  } catch (error) {
    const duration = performance.now() - start;

    apiMetricsManager.record(duration, "failed");

    throw error;
  }
};
